import { hasUstawotekaPathPrefix } from './baseUrl';

const IS_DEV_USTAWOTEKA_MODE = import.meta.env.VITE_IS_DEV_USTAWOTEKA_MODE === 'true';
export const APP_TESTY = 'testy';
export const APP_USTAWOTEKA = 'ustawoteka';
export const APP_LOCALHOST = 'localhost';
export const APP_OTHER = 'other';

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export const IS_PATH_USTAWOTEKA: boolean = hasUstawotekaPathPrefix();

export const APP_MODE =
	IS_PATH_USTAWOTEKA
		? APP_USTAWOTEKA
		: hostname === 'ustawoteka.iusvitae.pl' || IS_DEV_USTAWOTEKA_MODE
			? APP_USTAWOTEKA
			: hostname === 'testy.iusvitae.pl'
				|| hostname === 'mobile.iusvitae.com.pl'
				|| hostname === 'test-iusvitae.usermd.net'
				|| hostname === 'admin.iusvitae.com.pl'
				? APP_TESTY
				: hostname === 'localhost'
					? APP_LOCALHOST
					: APP_OTHER;
